import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import CheckImg from '../assets/images/certificates/blue_check.png';
import PolygonImg from '../assets/images/certificates/polygon_explain.png';
import NoValidationImg from '../assets/images/certificates/no_validation_warning.png';
import DnsValidatedImg from '../assets/images/certificates/dns_validated.png';
import { useTranslation, Trans } from 'react-i18next';

export default function Faqs() {
    const { t } = useTranslation();
    const accordionStyle = {
        '&:before': {
            display: 'none',
        },
    };
    return (
        <div className="faq_background">
            <Stack px={{ xs: 0, md: 6 }} py={2}>
                <Typography variant="h2" mb={3} textAlign={'center'}>
                    {t('faqs.title')}
                </Typography>
                <Accordion sx={accordionStyle}>
                    <AccordionSummary expandIcon={<Arrow />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography variant="body1">{t('faqs.q1')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2">
                            <Trans i18nKey="faqs.a1"></Trans>
                        </Typography>
                        <Typography variant="body2" component={'span'}>
                            <ul>
                                <li>{t('faqs.a1_2')}</li>
                                <li>
                                    {t('faqs.a1_3')} <img src={CheckImg} alt="check" height={'12px'} />
                                </li>
                            </ul>
                        </Typography>
                        <Typography variant="body2">{t('faqs.a1_4')}</Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={accordionStyle}>
                    <AccordionSummary expandIcon={<Arrow />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography variant="body1">{t('faqs.q2')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2">
                            <Trans i18nKey="faqs.a2"></Trans>
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={accordionStyle}>
                    <AccordionSummary expandIcon={<Arrow />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography variant="body1">{t('faqs.q3')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2">
                            <Trans i18nKey="faqs.a3"></Trans>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion sx={accordionStyle}>
                    <AccordionSummary expandIcon={<Arrow />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography variant="body1">{t('faqs.q4')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2">
                            <Trans i18nKey="faqs.a4"></Trans>
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={accordionStyle}>
                    <AccordionSummary expandIcon={<Arrow />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography variant="body1">{t('faqs.q5')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2">{t('faqs.a5')}</Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={accordionStyle}>
                    <AccordionSummary expandIcon={<Arrow />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography variant="body1">{t('faqs.q6')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2">{t('faqs.a6')}</Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={accordionStyle}>
                    <AccordionSummary expandIcon={<Arrow />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography variant="body1">{t('faqs.q7')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2">
                            <Trans i18nKey="faqs.a7"></Trans>
                            <img
                                src={PolygonImg}
                                alt="polygon"
                                width={'90%'}
                                style={{ marginTop: '12px', marginBottom: '12px' }}
                            />
                            <br />
                            <Trans i18nKey="faqs.a7_2"></Trans>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion sx={accordionStyle}>
                    <AccordionSummary expandIcon={<Arrow />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography variant="body1">{t('faqs.q8')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2">
                            <Trans i18nKey="faqs.a8"></Trans>
                            <img
                                src={NoValidationImg}
                                alt="warning"
                                width={'100%'}
                                style={{ marginTop: '12px', marginBottom: '12px' }}
                            />
                            <br />
                            <Trans i18nKey="faqs.a8_2"></Trans>
                            <br />
                        </Typography>
                        <Typography variant="body2" component={'span'}>
                            <div
                                style={{
                                    textAlign: 'center',
                                }}
                            >
                                <img
                                    src={DnsValidatedImg}
                                    alt="warning"
                                    width={'200px'}
                                    style={{
                                        marginTop: '12px',
                                        marginBottom: '12px',
                                        textAlign: 'center',
                                    }}
                                />
                            </div>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Stack>
        </div>
    );
}
export const Arrow = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.9996 15.2606C11.8286 15.2606 11.6612 15.228 11.4975 15.1627C11.3337 15.0975 11.1877 15.0008 11.0594 14.8725L6.47353 10.2867C6.22425 10.0374 6.09961 9.72869 6.09961 9.36057C6.09961 8.99245 6.22425 8.68375 6.47353 8.43447C6.72282 8.18519 7.03152 8.06055 7.39963 8.06055C7.76775 8.06055 8.07645 8.18519 8.32573 8.43447L11.9996 12.1084L15.6735 8.43447C15.9228 8.18519 16.2315 8.06055 16.5996 8.06055C16.9678 8.06055 17.2765 8.18519 17.5257 8.43447C17.775 8.68375 17.8997 8.99245 17.8997 9.36057C17.8997 9.72869 17.775 10.0374 17.5257 10.2867L12.9399 14.8725C12.8116 15.0008 12.6656 15.0975 12.5018 15.1627C12.338 15.228 12.1707 15.2606 11.9996 15.2606Z"
                fill="black"
            />
        </svg>
    );
};
